import { paths } from "@rms-types/constants/paths";
import { lazy } from "react";

import { complianceRoutes } from "./compliance-routes";
import { intakeRoutes } from "./intake-routes";
import { messageRoutes } from "./message-routes";
import { organizationRoutes } from "./organization-routes";
import { queueRoutes } from "./queue-routes";
import { settingsRoutes } from "./settings-routes";
import { userManagementRoutes } from "./user-management-routes";

import { AppRoute } from "@/routes/types";

export const privateRoutes: AppRoute[] = [
  {
    path: paths.app.root.path,
    page: lazy(() =>
      import("@/features/auth/components/PrivateApp").then((module) => ({ default: module.PrivateApp }))
    ),
    children: [
      {
        path: paths.app.dashboard.path,
        permissions: paths.app.dashboard.permissions,
        page: lazy(() => import("@/pages/dashboard").then((module) => ({ default: module.Dashboard }))),
      },
      {
        path: paths.app.intakes.path,
        permissions: paths.app.intakes.permissions,
        page: lazy(() =>
          import("@/layouts/expanding-sidebar-layout").then((module) => ({ default: module.ExpandingSidebarLayout }))
        ),
        children: intakeRoutes,
      },
      {
        path: paths.app.applicationPortals.path,
        permissions: paths.app.applicationPortals.permissions,
        page: lazy(() => import("@/pages/applicant-portals").then((module) => ({ default: module.ApplicantPortals }))),
      },
      {
        path: paths.app.queue.path,
        permissions: paths.app.queue.permissions,
        page: lazy(() =>
          import("@/layouts/expanding-sidebar-layout").then((module) => ({ default: module.ExpandingSidebarLayout }))
        ),
        children: queueRoutes,
      },
      {
        path: paths.app.workload.path,
        permissions: paths.app.workload.permissions,
        page: lazy(() => import("@/pages/workload").then((module) => ({ default: module.Workload }))),
      },
      {
        path: paths.app.userManagement.path,
        permissions: paths.app.userManagement.permissions,
        page: lazy(() =>
          import("@/layouts/expanding-sidebar-layout").then((module) => ({ default: module.ExpandingSidebarLayout }))
        ),
        children: userManagementRoutes,
      },
      {
        path: paths.app.organizations.path,
        permissions: paths.app.organizations.permissions,
        page: lazy(() =>
          import("@/layouts/expanding-sidebar-layout").then((module) => ({ default: module.ExpandingSidebarLayout }))
        ),
        children: organizationRoutes,
      },
      {
        path: paths.app.compliance.path,
        permissions: paths.app.compliance.permissions,
        page: lazy(() => import("@/layouts/content-layout").then((module) => ({ default: module.ContentLayout }))),
        children: complianceRoutes,
      },
      {
        path: paths.app.messages.path,
        permissions: paths.app.messages.permissions,
        page: lazy(() =>
          import("@/features/message/layouts/message-sidebar").then((module) => ({
            default: module.MessageExpandingSidebarLayout,
          }))
        ),
        children: messageRoutes,
      },
      {
        path: paths.app.settings.path,
        permissions: paths.app.settings.permissions,
        page: lazy(() =>
          import("@/layouts/expanding-sidebar-layout").then((module) => ({ default: module.ExpandingSidebarLayout }))
        ),
        children: settingsRoutes,
      },
    ],
  },
];
